export default __webpack_public_path__ + "static/facetime-call-f6660b92e8f015743a9d02f1472d26be.png";